<ng-container *ngIf="listMode;else detailMode">
        <div *ngFor="let section of sections" class="input-cell">
            <kve-section-navigator [section]="section" [renderedSections]="renderedSections" (selectedSectionId)="editSection($event)" (deselectRest)="toggleSelection($event)"></kve-section-navigator>
        </div>
</ng-container>
<ng-template #detailMode>
    <ng-container [ngSwitch]="selectedSection.rendererType">
        <ng-container *ngSwitchCase="'GRID'">
            <kve-grid-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-grid-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'grid'">
            <kve-grid-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-grid-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'row'">
            <kve-row-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-row-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'banner'">
            <kve-banner-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-banner-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'bloglist'">
            <kve-bloglist-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-bloglist-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'category'">
            <kve-category-section-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-category-section-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'product'">
            <kve-product-section-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-product-section-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'slider'">
            <kve-slider-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-slider-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'hero-image'">
            <kve-grid-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-grid-editor>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <kve-banner-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-banner-editor>
            <!-- <kve-testimonial-editor [selectedSection]="selectedSection" [selectedRenderedSection]="selectedRenderedSection" (setListMode)="toggleListMode($event)"></kve-testimonial-editor> -->
        </ng-container>
    </ng-container>
</ng-template>
